import type { Goal } from "shared/types";
import type { LotGoalFilterFormState } from "../lotGoal.types";

export enum LotGoalStatusFilter {
  All = 0,
  Active = 1,
  Inactive = 2,
}

export enum LotGoalListTableColumn {
  Name = "name",
  Edit = "edit",
  Status = "status",
}

function isFilteredByName(name: string, searchText: string): boolean {
  if (searchText.trim() === "") {
    return true;
  }

  return name.toUpperCase().includes(searchText.trim().toUpperCase());
}

function isFilteredByStatus(
  deletionUser: string | null,
  deletedAt: string | null,
  filter: LotGoalStatusFilter
): boolean {
  if (filter === LotGoalStatusFilter.All) {
    return true;
  }

  if (filter === LotGoalStatusFilter.Active) {
    return deletionUser == null && deletedAt == null;
  }

  return deletionUser != null || deletedAt != null;
}

export function filterLotGoalPredicate(
  item: Goal,
  filter: LotGoalFilterFormState
): boolean {
  const matchesSearchText = isFilteredByName(item.name, filter.searchText);

  const matchesStatus = isFilteredByStatus(
    item.deletionUser,
    item.deletedAt,
    filter.status
  );

  return matchesSearchText && matchesStatus;
}
